document.addEventListener('DOMContentLoaded', () => {
  const tabsContainers = document.querySelectorAll('[data-content-tabs]');

  tabsContainers.forEach(container => {
    const buttons = container.querySelectorAll('.content-tabs__button');
    const contents = container.querySelectorAll('.content-tabs__content');

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        buttons.forEach(btn => btn.classList.remove('is-active'));
        contents.forEach(content => content.classList.remove('is-active'));

        button.classList.add('is-active');

        const targetId = button.getAttribute('data-tab-target');
        const targetContent = document.getElementById(targetId);
        if (targetContent) {
          targetContent.classList.add('is-active');
        }
      });
    });
  });
});
